import type { BridgeActions, BridgeState } from '#ui-shared/stores/app-bridge/types';

/**
 * A class that serves as an interface for the app bridge, allowing registration of action handlers and maintaining the state of the bridge.
 * @template TActions - The type of actions that can be registered with the bridge.
 * @template TState - The type of state that the bridge maintains, defaulting to BridgeState.
 */
export class BridgeInterface<
  TActions extends BridgeActions,
  TState extends BridgeState = BridgeState,
> {
  constructor(
    readonly actions: TActions,
    public state: TState,
  ) {}

  registerHandler<K extends keyof TActions>(actionName: K, handler: TActions[K]): void {
    this.actions[actionName] = handler;
  }
}
